export default __webpack_public_path__ + "static/media/logo_dlt.02bbd14e.png";